import { render } from "./DocumentMosaicItem.vue?vue&type=template&id=7eed5e64&scoped=true"
import script from "./DocumentMosaicItem.vue?vue&type=script&lang=js"
export * from "./DocumentMosaicItem.vue?vue&type=script&lang=js"

import "./DocumentMosaicItem.vue?vue&type=style&index=0&id=7eed5e64&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eed5e64"]])

export default __exports__